module.exports = __webpack_public_path__ + "ir.a7013c080608684be098.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ir.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ir.svg
// module chunks = styles